import { BodyMath } from "../../bodies/BodyMath.js";
import { SEarthRotationModel } from "../rotation/SEarthRotationModel.js";
import { VSOP87Orbit, VSOPSeries } from "./VSOP87Orbits.js";
class VSOP87OrbitsEarth {
    static earth_L0 = [
        1.75347045673, 0, 0, 0.03341656453, 4.66925680415, 6283.07584999,
        0.00034894275, 4.62610242189, 12566.1517, 3.417572e-5, 2.82886579754,
        3.523118349, 3.497056e-5, 2.74411783405, 5753.3848849, 3.135899e-5,
        3.62767041756, 77713.7714681, 2.676218e-5, 4.41808345438, 7860.41939244,
        2.342691e-5, 6.13516214446, 3930.20969622, 1.273165e-5, 2.03709657878,
        529.690965095, 1.324294e-5, 0.74246341673, 11506.7697698, 9.01854e-6,
        2.04505446477, 26.2983197998, 1.199167e-5, 1.10962946234, 1577.34354245,
        8.57223e-6, 3.50849152283, 398.149003408, 7.79786e-6, 1.17882681962,
        5223.6939198, 9.9025e-6, 5.23268072088, 5884.92684658, 7.53141e-6,
        2.53339052847, 5507.55323867, 5.05267e-6, 4.58292599973, 18849.22755,
        4.92392e-6, 4.20505711826, 775.522611324, 3.56672e-6, 2.91954114478,
        0.0673103028, 2.84125e-6, 1.89869240932, 796.298006816, 2.42879e-6,
        0.34481445893, 5486.77784318, 3.17087e-6, 5.84901948512, 11790.6290887,
        2.71112e-6, 0.31486255375, 10977.0788047, 2.06217e-6, 4.80646631478,
        2544.31441988, 2.05478e-6, 1.86953770281, 5573.14280143, 2.02318e-6,
        2.45767790232, 6069.77675455, 1.26225e-6, 1.08295459501, 20.7753954924,
        1.55516e-6, 0.83306084617, 213.299095438, 1.15132e-6, 0.64544911683,
        0.9803210682, 1.02851e-6, 0.63599845579, 4694.00295471, 1.01724e-6,
        4.2667980198, 7.1135470008, 9.9206e-7, 6.20992926918, 2146.16541648,
        1.32212e-6, 3.41118292683, 2942.46342329, 9.7607e-7, 0.68101342359,
        155.420399434, 8.5128e-7, 1.29870764804, 6275.96230299, 7.4651e-7,
        1.755089133, 5088.62883977, 1.01895e-6, 0.97569280312, 15720.8387849,
        8.4711e-7, 3.67080093031, 71430.6956181, 7.3547e-7, 4.67926633877,
        801.820931124, 7.3874e-7, 3.50319414955, 3154.6870849, 7.8757e-7,
        3.03697458703, 12036.4607349, 7.9637e-7, 1.80791287082, 17260.1546547,
        8.5803e-7, 5.9832263126, 161000.685738, 5.6963e-7, 2.78430458592,
        6286.59896834, 6.1148e-7, 1.81839892984, 7084.89678112, 6.9627e-7,
        0.83297621398, 9437.76293489, 5.6116e-7, 4.38694865354, 14143.4952424,
        6.2449e-7, 3.97763912806, 8827.39026987, 5.1145e-7, 0.28306832879,
        5856.47765912, 5.5577e-7, 3.47006059924, 6279.55273164, 4.1036e-7,
        5.36817592855, 8429.24126647, 5.1605e-7, 1.33282739866, 1748.01641307,
        5.1992e-7, 0.18914947184, 12139.5535091, 4.9e-7, 0.48735014197,
        1194.44701022, 3.92e-7, 6.16833020996, 10447.3878396, 3.557e-7,
        1.775968892, 6812.76681509, 3.677e-7, 6.04133863162, 10213.2855462,
        3.6596e-7, 2.56957481827, 1059.38193019, 3.3296e-7, 0.59310278598,
        17789.8456198, 3.5954e-7, 1.70875808777, 2352.86615377,
        // 61 terms retained
        4.0938e-7, 2.39850938714, 19651.0484811,
    ];
    static earth_L1 = [
        6283.07584999, 0, 0, 0.00206058863, 2.67823455808, 6283.07584999,
        4.303419e-5, 2.63512233481, 12566.1517, 4.25264e-6, 1.59046982018,
        3.523118349, 1.09017e-6, 2.96631010675, 1577.34354245, 9.3479e-7,
        2.59211109542, 18849.22755, 1.19305e-6, 5.79555765566, 26.2983197998,
        7.2121e-7, 1.13840581212, 529.690965095, 6.7784e-7, 1.87453300345,
        398.149003408, 6.735e-7, 4.40932832004, 5507.55323867, 5.9045e-7,
        2.88815790631, 5223.6939198, 5.5976e-7, 2.17471740035, 155.420399434,
        4.5411e-7, 0.39799502896, 796.298006816, 3.6298e-7, 0.46875437227,
        775.522611324, 2.8962e-7, 2.64732254645, 7.1135470008, 1.9097e-7,
        1.84628376049, 5486.77784318, 2.0844e-7, 5.34138275149, 0.9803210682,
        1.8508e-7, 4.96855179468, 213.299095438, 1.6233e-7, 0.03216587315,
        2544.31441988, 1.7293e-7, 2.9911676063, 6275.96230299, 1.5832e-7,
        1.43049301283, 2146.16541648, 1.4608e-7, 1.2046979369, 10977.0788047,
        1.1877e-7, 3.25805082007, 5088.62883977, 1.1514e-7, 2.07502080082,
        4694.00295471, 9.721e-8, 4.2392586526, 1349.86740966, 9.969e-8,
        1.30263423409, 6286.59896834, 9.452e-8, 2.69956827011, 242.728603974,
        1.2461e-7, 2.83432282119, 1748.01641307, 1.1808e-7, 5.27379760438,
        1194.44701022, 8.577e-8, 5.6447608598, 951.718406251, 1.0641e-7,
        0.76614722966, 553.569402842, 7.576e-8, 5.30056172859, 2352.86615377,
        5.764e-8, 1.77228445837, 1059.38193019, 6.385e-8, 2.65034514038,
        9437.76293489, 5.223e-8, 5.66135782131, 71430.6956181, 5.315e-8,
        0.91110018969, 3154.6870849, 6.101e-8, 4.66633726278, 4690.47983636,
        4.335e-8, 0.23934560382, 6812.76681509, 5.041e-8, 1.42489704722,
        6438.49624943, 4.259e-8, 0.77355543889, 10447.3878396,
        // 41 terms retained
        5.2e-8, 1.85528830215, 801.820931124,
    ];
    static earth_L2 = [
        8.721859e-5, 1.07253635559, 6283.07584999, 9.9099e-6, 3.14159265359, 0,
        2.94833e-6, 0.43717350256, 12566.1517, 2.7338e-7, 0.05295636147,
        3.523118349, 1.6333e-7, 5.18820215724, 26.2983197998, 1.5745e-7,
        3.68504712183, 155.420399434, 9.425e-8, 0.29667114694, 18849.22755,
        8.938e-8, 2.05706319592, 77713.7714681, 6.94e-8, 0.82691541038,
        775.522611324, 5.061e-8, 4.6624323168, 1577.34354245, 4.06e-8,
        1.03067032318, 7.1135470008, 3.464e-8, 5.14021224609, 796.298006816,
        3.172e-8, 6.05479318507, 5507.55323867, 3.02e-8, 1.19240008524,
        242.728603974, 2.885e-8, 6.11705865396, 529.690965095, 3.809e-8,
        3.44043369494, 5573.14280143, 2.719e-8, 0.30363248164, 398.149003408,
        2.365e-8, 4.37666117992, 5223.6939198, 2.538e-8, 2.27966434314,
        553.569402842, 2.078e-8, 3.75435095487, 0.9803210682,
        // 27 terms retained
        1.675e-8, 0.90149951436, 951.718406251, 1.534e-8, 5.75895831192,
        1349.86740966, 1.224e-8, 2.97285792195, 2146.16541648, 1.449e-8,
        4.36401639552, 1748.01641307, 1.341e-8, 3.72019379666, 1194.44701022,
        1.253e-8, 2.9488872631, 6438.49624943, 9.99e-9, 5.98665341008,
        6286.59896834,
    ];
    // 5 terms retained
    static earth_L3 = [
        2.89058e-6, 5.84173149732, 6283.07584999, 2.0712e-7, 6.0498393902,
        12566.1517, 2.962e-8, 5.1956057957, 155.420399434, 2.527e-8,
        3.14159265359, 0, 1.288e-8, 4.7219761197, 3.523118349,
    ];
    // 1 terms retained
    static earth_L4 = [7.714e-8, 4.14117321449, 6283.07584999];
    // 0 terms retained
    static earth_L5 = [0, 0, 0];
    // 1 terms retained
    static earth_B0 = [2.7962e-6, 3.19870156017, 84334.6615813];
    // 4 terms retained
    static earth_B1 = [
        0.00227777722, 3.4137662053, 6283.07584999, 3.805678e-5, 3.37063423795,
        12566.1517, 3.619589e-5, 0, 0, 7.1542e-7, 3.32777549735, 18849.22755,
    ];
    // 4 terms retained
    static earth_B2 = [
        9.721424e-5, 5.1519280992, 6283.07584999, 2.33002e-6, 3.14159265359, 0,
        1.34188e-6, 0.64406212977, 12566.1517, 6.504e-8, 1.07333397797,
        18849.22755,
    ];
    // static earth_B3: number[] = [
    //     2.75993e-6, 0.59480097092, 6283.07584999, 1.7034e-7, 3.14159265359, 0,
    //     3.617e-8, 0.11750575325, 12566.1517,
    //     // 3 terms retained
    // ];
    // static earth_B4: number[] = [
    //     5.745e-8, 2.26734029843, 6283.07584999,
    //     // 1 terms retained
    // ];
    // static earth_B5: number[] = [
    //     0, 0, 0,
    //     // 0 terms retained
    // ];
    static earth_R0 = [
        1.00013988784, 0, 0, 0.01670699632, 3.09846350258, 6283.07584999,
        0.00013956024, 3.05524609456, 12566.1517, 3.08372e-5, 5.19846674381,
        77713.7714681, 1.628463e-5, 1.17387558054, 5753.3848849, 1.575572e-5,
        2.84685214877, 7860.41939244, 9.24799e-6, 5.45292236722, 11506.7697698,
        5.42439e-6, 4.56409151453, 3930.20969622, 4.7211e-6, 3.66100022149,
        5884.92684658, 3.2878e-6, 5.89983686142, 5223.6939198, 3.45969e-6,
        0.96368627272, 5507.55323867, 3.06784e-6, 0.29867139512, 5573.14280143,
        1.74844e-6, 3.01193636733, 18849.22755, 2.43181e-6, 4.2734953079,
        11790.6290887, 2.11836e-6, 5.84714461348, 1577.34354245, 1.8574e-6,
        5.02199710705, 10977.0788047, 1.09835e-6, 5.0551063586, 5486.77784318,
        9.8316e-7, 0.88681311278, 6069.77675455, 8.65e-7, 5.68956418946,
        15720.8387849, 8.5831e-7, 1.27079125277, 161000.685738, 6.2917e-7,
        0.92177053978, 529.690965095, 5.7056e-7, 2.01374292245, 83996.8473181,
        6.4908e-7, 0.27251341435, 17260.1546547, 4.9384e-7, 3.24501240359,
        2544.31441988, 5.5736e-7, 5.2415979917, 71430.6956181, 4.252e-7,
        6.01110257982, 6275.96230299, 4.6966e-7, 2.57799853213, 775.522611324,
        3.8963e-7, 5.36063832897, 4694.00295471, 4.4666e-7, 5.53715663816,
        9437.76293489, 3.5661e-7, 1.67447135798, 12036.4607349, 3.1922e-7,
        0.18368299942, 5088.62883977, 3.1846e-7, 1.77775642078, 398.149003408,
        3.3193e-7, 0.24370221704, 7084.89678112, 3.8245e-7, 2.39255343973,
        8827.39026987, 2.8468e-7, 1.21344887533, 6286.59896834, 3.7486e-7,
        0.82961281844, 19651.0484811, 3.6957e-7, 4.90107587287, 12139.5535091,
        3.4537e-7, 1.84270693281, 2942.46342329, 2.6275e-7, 4.58896863104,
        10447.3878396, 2.4596e-7, 3.78660838036, 8429.24126647, 2.3587e-7,
        0.26866098169, 796.298006816, 2.7795e-7, 1.89934427832, 6279.55273164,
        2.3927e-7, 4.99598548145, 5856.47765912, 2.0345e-7, 4.65282190725,
        2146.16541648, 2.3287e-7, 2.80783632869, 14143.4952424, 2.2099e-7,
        1.95002636847, 3154.6870849, 1.9509e-7, 5.38233922479, 2352.86615377,
        1.7958e-7, 0.1987136996, 6812.76681509, 1.7178e-7, 4.43322156854,
        10213.2855462, 1.619e-7, 5.23159323213, 17789.8456198, 1.7315e-7,
        6.15224075188, 16730.4636896, 1.3814e-7, 5.18962074032, 8031.09226306,
        1.8834e-7, 0.67280058021, 149854.400135, 1.833e-7, 2.25348717053,
        23581.2581773, 1.3639e-7, 3.68511810757, 4705.73230754, 1.3142e-7,
        0.65267698994, 13367.9726311, 1.0414e-7, 4.33285688501, 11769.8536932,
        9.978e-8, 4.20126336356, 6309.37416979, 1.017e-7, 1.59366684542,
        4690.47983636, 7.564e-8, 2.62560597391, 6256.77753019, 9.654e-8,
        3.67583728703, 27511.4678735, 6.743e-8, 0.56269927047, 3340.6124267,
        8.743e-8, 6.06359123461, 1748.01641307, 7.786e-8, 3.67371235367,
        12168.0026966, 6.633e-8, 5.66149277789, 11371.7046898, 7.712e-8,
        0.31242577788, 7632.94325965, 6.586e-8, 3.13580054586, 801.820931124,
        7.46e-8, 5.6475806666, 11926.2544137, 6.933e-8, 2.92384586372,
        6681.2248534, 6.805e-8, 1.42327153767, 23013.5395396,
        // 72 terms retained
        6.118e-8, 5.13395999022, 1194.44701022, 6.477e-8, 2.64986648493,
        19804.8272916,
    ];
    // 10 terms retained
    static earth_R1 = [
        0.00103018607, 1.10748968172, 6283.07584999, 1.721238e-5, 1.06442300386,
        12566.1517, 7.02217e-6, 3.14159265359, 0, 3.2345e-7, 1.02168583254,
        18849.22755, 3.0801e-7, 2.84358443952, 5507.55323867, 2.4978e-7,
        1.31906570344, 5223.6939198, 1.8487e-7, 1.42428709076, 1577.34354245,
        1.0077e-7, 5.91385248388, 10977.0788047, 8.635e-8, 0.27158192945,
        5486.77784318, 8.654e-8, 1.42046854427, 6275.96230299,
    ];
    // 6 terms retained
    static earth_R2 = [
        4.359385e-5, 5.78455133808, 6283.07584999, 1.23633e-6, 5.57935427994,
        12566.1517, 1.2342e-7, 3.14159265359, 0, 8.792e-8, 3.62777893099,
        77713.7714681, 5.689e-8, 1.86958905084, 5573.14280143, 3.302e-8,
        5.47034879713, 18849.22755,
    ];
    // 2 terms retained
    static earth_R3 = [
        1.44595e-6, 4.27319433901, 6283.07584999, 6.729e-8, 3.91706261708,
        12566.1517,
    ];
    // 1 terms retained
    static earth_R4 = [3.858e-8, 2.56389016346, 6283.07584999];
    // 0 terms retained
    static earth_R5 = [0, 0, 0];
    static earth_L = [
        new VSOPSeries(VSOP87OrbitsEarth.earth_L0),
        new VSOPSeries(VSOP87OrbitsEarth.earth_L1),
        new VSOPSeries(VSOP87OrbitsEarth.earth_L2),
        new VSOPSeries(VSOP87OrbitsEarth.earth_L3),
        new VSOPSeries(VSOP87OrbitsEarth.earth_L4),
        new VSOPSeries(VSOP87OrbitsEarth.earth_L5),
    ];
    static earth_B = [
        new VSOPSeries(VSOP87OrbitsEarth.earth_B0),
        new VSOPSeries(VSOP87OrbitsEarth.earth_B1),
        new VSOPSeries(VSOP87OrbitsEarth.earth_B2),
    ];
    static earth_R = [
        new VSOPSeries(VSOP87OrbitsEarth.earth_R0),
        new VSOPSeries(VSOP87OrbitsEarth.earth_R1),
        new VSOPSeries(VSOP87OrbitsEarth.earth_R2),
        new VSOPSeries(VSOP87OrbitsEarth.earth_R3),
        new VSOPSeries(VSOP87OrbitsEarth.earth_R4),
        new VSOPSeries(VSOP87OrbitsEarth.earth_R5),
    ];
}
export function createEarthBodyMath(sun) {
    return new BodyMath(new VSOP87Orbit(VSOP87OrbitsEarth.earth_L, VSOP87OrbitsEarth.earth_B, VSOP87OrbitsEarth.earth_R, 365.25, 160000000.0), new SEarthRotationModel(), // new EarthRotationModel()
    BodyMath.EclipticFrame, sun);
}
